import { createClient } from "@supabase/supabase-js";
import { PUBLIC_CONFIG } from "./publicConfig";

const SUPABASE_URL = PUBLIC_CONFIG.SUPABASE_URL;
const SUPABASE_ANON_KEY = PUBLIC_CONFIG.SUPABASE_ANON_KEY;

export const isSupabaseAuthConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

export const supabase = isSupabaseAuthConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  : null;
